export const TabsWrapperMixins = {
  methods: {
    slotName(name){
      return `tab-panel-${name}`
    },
    slotActivePanelName(name){
      return `tab-active-panel-${name}`
    }
  }
}